module.exports = __webpack_public_path__ + "media/images/peb/8mm/peb_d-ed87b618f8c8cda84683bac8090017af.png";